export const EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];

function isDigits(str) {
    return /^\d+$/.test(str);
}

function mod97(numStr) {
    let remainder = 0;
    for (let i = 0; i < numStr.length; i++) {
        remainder = (remainder * 10 + parseInt(numStr[i], 10)) % 97;
    }
    return remainder;
}

export function checkVatAT(vat) {
    if (vat.length !== 9) {
        return false;
    }
    if (vat[0].toUpperCase() !== 'U') {
        return false;
    }
    const digits = vat.substring(1);
    if (!isDigits(digits)) {
        return false;
    }

    const weights = [1, 2, 1, 2, 1, 2, 1];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        const temp = parseInt(digits[i], 10) * weights[i];
        sum += Math.floor(temp / 10) + (temp % 10);
    }
    const check = (96 - sum) % 10;
    return check === parseInt(digits[7], 10);
}

export function checkVatBE(vat) {
    if (vat.length === 9) {
        vat = '0' + vat;
    }
    if (vat.length !== 10) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }
    if (vat[0] !== '0') {
        return false;
    }

    const number = parseInt(vat.substring(0, 8), 10);
    const check = parseInt(vat.substring(8, 10), 10);
    return (97 - (number % 97)) === check;
}

function checkVatBG9(vat) {
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * (i + 1);
    }
    let check = sum % 11;
    if (check === 10) {
        sum = 0;
        for (let i = 0; i < 8; i++) {
            sum += parseInt(vat[i], 10) * (i + 3);
        }
        check = sum % 11;
        if (check === 10) {
            check = 0;
        }
    }
    return check === parseInt(vat[8], 10);
}

function checkVatBG10(vat) {
    const weights1 = [2, 4, 8, 5, 10, 9, 7, 3, 6];
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(vat[i], 10) * weights1[i];
    }
    let check = sum % 11;
    if (check === 10) {
        check = 0;
    }
    if (check === parseInt(vat[9], 10)) {
        return true;
    }

    const weights2 = [21, 19, 17, 13, 11, 9, 7, 3, 1];
    sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(vat[i], 10) * weights2[i];
    }
    check = sum % 10;
    return check === parseInt(vat[9], 10);
}

export function checkVatBG(vat) {
    if (!isDigits(vat)) {
        return false;
    }
    if (vat.length === 9) {
        return checkVatBG9(vat);
    }
    if (vat.length === 10) {
        return checkVatBG10(vat);
    }
    return false;
}

export function checkVatCY(vat) {
    if (vat.length !== 9) {
        return false;
    }
    const digits = vat.substring(0, 8);
    const lastChar = vat[8].toUpperCase();
    if (!isDigits(digits)) {
        return false;
    }
    if (!/^[A-Z]$/.test(lastChar)) {
        return false;
    }
    if (vat.startsWith('12')) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 8; i++) {
        let d = parseInt(digits[i], 10);
        if (i % 2 === 0) {
            const map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21];
            d = map[d];
        }
        sum += d;
    }
    const check = sum % 26;
    return lastChar === String.fromCharCode(65 + check);
}

function checkVatCZ8(vat) {
    const weights = [8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    const check = (11 - (sum % 11)) % 10;
    return check === parseInt(vat[7], 10);
}

function checkVatCZ910(vat) {
    if (vat.length === 10) {
        const num = parseInt(vat, 10);
        return num % 11 === 0;
    }
    return true;
}

export function checkVatCZ(vat) {
    if (!isDigits(vat)) {
        return false;
    }
    if (vat.length === 8) {
        return checkVatCZ8(vat);
    }
    if (vat.length === 9 || vat.length === 10) {
        return checkVatCZ910(vat);
    }
    return false;
}

export function checkVatDE(vat) {
    if (vat.length !== 9) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    let product = 10;
    for (let i = 0; i < 8; i++) {
        let sum = (parseInt(vat[i], 10) + product) % 10;
        if (sum === 0) {
            sum = 10;
        }
        product = (2 * sum) % 11;
    }
    const check = (11 - product) % 10;
    return check === parseInt(vat[8], 10);
}

export function checkVatDK(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [2, 7, 6, 5, 4, 3, 2, 1];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    return sum % 11 === 0;
}

export function checkVatEE(vat) {
    if (vat.length !== 9) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [3, 7, 1, 3, 7, 1, 3, 7];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    const check = (10 - (sum % 10)) % 10;
    return check === parseInt(vat[8], 10);
}

function checkVatESNif(vat) {
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    if (/^[A-Z]/i.test(vat[0]) && /^[TKLM]/i.test(vat[0].toUpperCase())) {
        const number = vat.substring(1, 8);
        if (!isDigits(number)) {
            return false;
        }
        const check = letters[parseInt(number, 10) % 23];
        return vat[8].toUpperCase() === check;
    }
    const number = vat.substring(0, 8);
    if (!isDigits(number)) {
        return false;
    }
    const check = letters[parseInt(number, 10) % 23];
    return vat[8].toUpperCase() === check;
}

function checkVatESCif(vat) {
    const type = vat[0].toUpperCase();
    const digits = vat.substring(1, 8);
    if (!isDigits(digits)) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 7; i++) {
        let d = parseInt(digits[i], 10);
        if (i % 2 === 0) {
            d *= 2;
            d = Math.floor(d / 10) + (d % 10);
        }
        sum += d;
    }
    const check = (10 - (sum % 10)) % 10;
    const last = vat[8].toUpperCase();

    if (['P', 'Q', 'R', 'S', 'W', 'N'].includes(type)) {
        return last === String.fromCharCode(64 + check);
    }
    if (['A', 'B', 'D', 'E', 'F', 'G', 'H'].includes(type)) {
        return last === String(check);
    }
    return last === String(check) || last === String.fromCharCode(64 + check);
}

function checkVatESNie(vat) {
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const first = vat[0].toUpperCase();
    const replace = {X: '0', Y: '1', Z: '2'};
    const number = replace[first] + vat.substring(1, 8);
    if (!isDigits(number)) {
        return false;
    }
    const check = letters[parseInt(number, 10) % 23];
    return vat[8].toUpperCase() === check;
}

export function checkVatES(vat) {
    if (vat.length !== 9) {
        return false;
    }
    const first = vat[0].toUpperCase();

    if (/^[ABCDEFGHJNPQRSUVW]$/.test(first)) {
        return checkVatESCif(vat);
    }
    if (['X', 'Y', 'Z'].includes(first)) {
        return checkVatESNie(vat);
    }
    if (isDigits(first) || ['T', 'K', 'L', 'M'].includes(first)) {
        return checkVatESNif(vat);
    }
    return false;
}

export function checkVatFI(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [7, 9, 10, 5, 8, 4, 2];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    let check = 11 - (sum % 11);
    if (check === 10) {
        return false;
    }
    if (check === 11) {
        check = 0;
    }
    return check === parseInt(vat[7], 10);
}

export function checkVatFR(vat) {
    if (vat.length !== 11) {
        return false;
    }
    const siren = vat.substring(2);
    if (!isDigits(siren)) {
        return false;
    }

    const key = vat.substring(0, 2);

    if (isDigits(key)) {
        const checkKey = (parseInt(siren, 10) * 100 + 12) % 97;
        return parseInt(key, 10) === checkKey;
    }

    if (/^[A-Z0-9]{2}$/i.test(key)) {
        const mapping = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
        const c1 = mapping.indexOf(key[0].toUpperCase());
        const c2 = mapping.indexOf(key[1].toUpperCase());
        if (c1 === -1 || c2 === -1) {
            return false;
        }

        let check;
        if (isDigits(key[0]) && /^[A-Z]$/i.test(key[1])) {
            check = c1 * 34 + c2 - 100;
        } else if (/^[A-Z]$/i.test(key[0]) && isDigits(key[1])) {
            check = c1 * 24 + parseInt(key[1], 10) - 10;
        } else {
            check = c1 * 24 + c2 - 100;
        }
        return (parseInt(siren, 10) + check + 1) % 11 === 0;
    }
    return false;
}

export function checkVatGB(vat) {
    const upper = vat.toUpperCase();
    if (/^GD[0-4]\d{2}$/.test(upper)) {
        return true;
    }
    if (/^HA[5-9]\d{2}$/.test(upper)) {
        return true;
    }

    if (!isDigits(vat)) {
        return false;
    }
    if (vat.length !== 9 && vat.length !== 12) {
        return false;
    }

    const number = parseInt(vat.substring(0, 7), 10);
    if (number === 0) {
        return false;
    }

    const check = parseInt(vat.substring(7, 9), 10);
    const weights = [8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }

    let remainder = sum % 97;
    if ((remainder === 0 && check === 0) || (97 - remainder === check)) {
        return true;
    }

    sum += 55;
    remainder = sum % 97;
    return (97 - remainder === check) || (remainder === 0 && check === 0);
}

export function checkVatGR(vat) {
    if (vat.length === 8) {
        vat = '0' + vat;
    }
    if (vat.length !== 9) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [256, 128, 64, 32, 16, 8, 4, 2];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    const check = (sum % 11) % 10;
    return check === parseInt(vat[8], 10);
}

export function checkVatHR(vat) {
    if (vat.length !== 11) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    let product = 10;
    for (let i = 0; i < 10; i++) {
        let sum = (parseInt(vat[i], 10) + product) % 10;
        if (sum === 0) {
            sum = 10;
        }
        product = (2 * sum) % 11;
    }
    const check = (11 - product) % 10;
    return check === parseInt(vat[10], 10);
}

export function checkVatHU(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [9, 7, 3, 1, 9, 7, 3];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    let check = sum % 10;
    if (check !== 0) {
        check = 10 - check;
    }
    return check === parseInt(vat[7], 10);
}

export function checkVatIE(vat) {
    const len = vat.length;
    if (len !== 8 && len !== 9) {
        return false;
    }

    const checkLetter = 'WABCDEFGHIJKLMNOPQRSTUV';

    if (len === 8) {
        if (/^[A-Z]/i.test(vat[1])) {
            const digits = '0' + vat.substring(2, 7) + vat[0];
            if (!isDigits(digits.replace(/ /g, ''))) {
                return false;
            }

            const weights = [8, 7, 6, 5, 4, 3, 2];
            let sum = 0;
            for (let i = 0; i < 7; i++) {
                sum += parseInt(digits[i], 10) * weights[i];
            }
            const check = sum % 23;
            if (check === 0) {
                return vat[7].toUpperCase() === 'W';
            }
            return vat[7].toUpperCase() === checkLetter[check];
        }

        const digits = vat.substring(0, 7);
        if (!isDigits(digits)) {
            return false;
        }
        if (!/^[A-Z]$/i.test(vat[7])) {
            return false;
        }

        const weights = [8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < 7; i++) {
            sum += parseInt(digits[i], 10) * weights[i];
        }
        const check = sum % 23;
        if (check === 0) {
            return vat[7].toUpperCase() === 'W';
        }
        return vat[7].toUpperCase() === checkLetter[check];
    }

    const digits = vat.substring(0, 7);
    if (!isDigits(digits)) {
        return false;
    }
    if (!/^[A-Z]$/i.test(vat[7]) || !/^[A-Z]$/i.test(vat[8])) {
        return false;
    }

    const weights = [8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(digits[i], 10) * weights[i];
    }
    sum += 9 * checkLetter.indexOf(vat[8].toUpperCase());
    const check = sum % 23;
    if (check === 0) {
        return vat[7].toUpperCase() === 'W';
    }
    return vat[7].toUpperCase() === checkLetter[check];
}

export function checkVatIT(vat) {
    if (vat.length !== 11) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 10; i++) {
        let d = parseInt(vat[i], 10);
        if (i % 2 !== 0) {
            d *= 2;
            if (d > 9) {
                d -= 9;
            }
        }
        sum += d;
    }
    const check = (10 - (sum % 10)) % 10;
    return check === parseInt(vat[10], 10);
}

function checkVatLT9(vat) {
    if (vat[7] !== '1') {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * (i + 1);
    }
    let check = sum % 11;
    if (check === 10) {
        const weights = [3, 4, 5, 6, 7, 8, 9, 1];
        sum = 0;
        for (let i = 0; i < 8; i++) {
            sum += parseInt(vat[i], 10) * weights[i];
        }
        check = sum % 11;
        if (check === 10) {
            check = 0;
        }
    }
    return check === parseInt(vat[8], 10);
}

function checkVatLT12(vat) {
    if (vat[10] !== '1') {
        return false;
    }

    const weights1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2];
    let sum = 0;
    for (let i = 0; i < 11; i++) {
        sum += parseInt(vat[i], 10) * weights1[i];
    }
    let check = sum % 11;
    if (check === 10) {
        const weights2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4];
        sum = 0;
        for (let i = 0; i < 11; i++) {
            sum += parseInt(vat[i], 10) * weights2[i];
        }
        check = sum % 11;
        if (check === 10) {
            check = 0;
        }
    }
    return check === parseInt(vat[11], 10);
}

export function checkVatLT(vat) {
    if (!isDigits(vat)) {
        return false;
    }
    if (vat.length === 9) {
        return checkVatLT9(vat);
    }
    if (vat.length === 12) {
        return checkVatLT12(vat);
    }
    return false;
}

export function checkVatLU(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const number = parseInt(vat.substring(0, 6), 10);
    const check = parseInt(vat.substring(6, 8), 10);
    return number % 89 === check;
}

export function checkVatLV(vat) {
    if (vat.length !== 11) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    if (parseInt(vat[0], 10) > 3) {
        const weights = [9, 1, 4, 8, 3, 10, 2, 5, 7, 6];
        let sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(vat[i], 10) * weights[i];
        }
        let check = 3 - (sum % 11);
        if (check < 0) {
            check += 11;
        }
        if (check === 10) {
            return false;
        }
        return check === parseInt(vat[10], 10);
    }

    return true;
}

export function checkVatMT(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [3, 4, 6, 7, 8, 9];
    let sum = 0;
    for (let i = 0; i < 6; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    const check = parseInt(vat.substring(6, 8), 10);
    return (37 - (sum % 37)) === check;
}

export function checkVatNL(vat) {
    vat = vat.toUpperCase();
    if (vat.length !== 12) {
        return false;
    }
    if (vat[9] !== 'B') {
        return false;
    }

    const digits = vat.substring(0, 9);
    const suffix = vat.substring(10, 12);
    if (!isDigits(digits) || !isDigits(suffix)) {
        return false;
    }

    const numStr = digits + '11' + suffix + '2321';
    const remainder = mod97(numStr);
    return remainder === 1;
}

export function checkVatPL(vat) {
    if (vat.length !== 10) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    return (sum % 11) === parseInt(vat[9], 10);
}

export function checkVatPT(vat) {
    if (vat.length !== 9) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    let check = (11 - (sum % 11)) % 11;
    if (check >= 10) {
        check = 0;
    }
    return check === parseInt(vat[8], 10);
}

export function checkVatRO(vat) {
    if (!isDigits(vat)) {
        return false;
    }
    if (vat.length < 2 || vat.length > 10) {
        return false;
    }

    const fullWeights = [7, 5, 3, 2, 1, 7, 5, 3, 2];
    const weights = fullWeights.slice(9 - (vat.length - 1));

    let sum = 0;
    for (let i = 0; i < vat.length - 1; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    let check = (sum * 10) % 11;
    if (check === 10) {
        check = 0;
    }
    return check === parseInt(vat[vat.length - 1], 10);
}

export function checkVatSE(vat) {
    if (vat.length !== 12) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }
    if (vat.substring(10, 12) !== '01') {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 10; i++) {
        let d = parseInt(vat[i], 10);
        if (i % 2 === 0) {
            d *= 2;
            if (d > 9) {
                d -= 9;
            }
        }
        sum += d;
    }
    return sum % 10 === 0;
}

export function checkVatSI(vat) {
    if (vat.length !== 8) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const weights = [8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += parseInt(vat[i], 10) * weights[i];
    }
    let check = 11 - (sum % 11);
    if (check === 10) {
        check = 0;
    }
    if (check === 11) {
        return false;
    }
    return check === parseInt(vat[7], 10);
}

export function checkVatSK(vat) {
    if (vat.length !== 10) {
        return false;
    }
    if (!isDigits(vat)) {
        return false;
    }

    const number = parseInt(vat, 10);
    return number % 11 === 0;
}

const validators = {
    AT: checkVatAT,
    BE: checkVatBE,
    BG: checkVatBG,
    CY: checkVatCY,
    CZ: checkVatCZ,
    DE: checkVatDE,
    DK: checkVatDK,
    EE: checkVatEE,
    ES: checkVatES,
    FI: checkVatFI,
    FR: checkVatFR,
    GB: checkVatGB,
    GR: checkVatGR,
    HR: checkVatHR,
    HU: checkVatHU,
    IE: checkVatIE,
    IT: checkVatIT,
    LT: checkVatLT,
    LU: checkVatLU,
    LV: checkVatLV,
    MT: checkVatMT,
    NL: checkVatNL,
    PL: checkVatPL,
    PT: checkVatPT,
    RO: checkVatRO,
    SE: checkVatSE,
    SI: checkVatSI,
    SK: checkVatSK,
};

export default function checkVat(countryCode, vatNumber) {
    const code = (countryCode || '').toUpperCase();
    const validator = validators[code];
    if (!validator) {
        return false;
    }
    return validator(String(vatNumber));
}
